

































































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { addreeAdd, editAddress, getNextAddress } from '@/utils/api';
import Locationpicker from '@/components/locationpicker.vue';
@Component({
  components: { Locationpicker },
})
export default class addNewAddress extends Vue {
  @Prop(String) title!: string;
  @Ref('locationpicker') locationpicker!: any;
  @Prop(Object) addressEdit!: object | undefined;
  @Watch('addressEdit', { immediate: true, deep: true })
  onPersonChanged1(val) {
    this.$nextTick(() => {
      this.locationpicker.resetFields();
    });
    if (val && this.title == '编辑地址') {
      this.addressSettings = JSON.parse(JSON.stringify(val));
    } else {
      this.addressSettings = {
        addressType: 'REFUND_GOODS_ADDRESS',
        userName: '',
        provinceId: 0,
        // 省Id
        provinceName: '',
        // 省 名称
        cityId: 0,
        // 市Id
        cityName: '',
        // 市 名称
        districtId: null,
        // 区Id
        districtName: '',
        // 区 名称
        addressDetail: '',
        iphone: '',
        defaultFlag: false,
        remark: '',
      };
    }
  }

  // 收集提交的地址
  addressSettings = {
    addressType: 'REFUND_GOODS_ADDRESS',
    userName: '',
    provinceId: 0,
    // 省Id
    provinceName: '',
    // 省 名称
    cityId: 0,
    // 市Id
    cityName: '',
    // 市 名称
    districtId: null,
    // 区Id
    districtName: '',
    // 区 名称
    addressDetail: '',
    iphone: '',
    defaultFlag: false,
    remark: '',
  };
  // 下拉框配置
  rules = {
    addressType: [{ required: true, message: '请输入', trigger: 'blur' }],
    userName: [{ required: true, message: '请输入', trigger: 'blur' }],
    addressDetail: [{ required: true, message: '请输入', trigger: 'blur' }],
    iphone: [{ required: true, message: '请输入', trigger: 'blur' }],
    districtId: [{ required: true, message: '请选择', trigger: 'blur' }],
  };

  // 添加get
  addreeAdd() {
    addreeAdd(this.addressSettings)
      .then((res) => {
        this.$message.success('添加成功');
        this.$refs['form']['resetFields']();
        this.$emit('getMessage', false);
      })
      .catch((err) => {
        console.log(err);
        this.$message.error(err);
      });
  }
  // 编辑get
  editAddress() {
    editAddress(this.addressSettings)
      .then((res) => {
        this.$message.success('编辑成功');
        this.$refs['form']['resetFields']();
        this.$emit('getMessage', false);
      })
      .catch((err) => {
        console.log(err);
        this.$message.error(err);
      });
  }
  // 保存
  saveForm(formName) {
    (this as any).$refs[formName].validate((valid) => {
      if (valid) {
        this.addressSettings = {
          ...this.addressSettings,
        };
        console.log(this.addressSettings);
        if (this.title == '添加地址') {
          this.addreeAdd();
        }
        if (this.title == '编辑地址') {
          this.editAddress();
        }
        this.$parent.$parent['dialog'] = false;
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  // 取消
  cancelForm() {
    this.addressSettings = {
      addressType: 'REFUND_GOODS_ADDRESS',
      userName: '',
      provinceId: 0,
      // 省Id
      provinceName: '',
      // 省 名称
      cityId: 0,
      // 市Id
      cityName: '',
      // 市 名称
      districtId: null,
      // 区Id
      districtName: '',
      // 区 名称
      addressDetail: '',
      iphone: '',
      defaultFlag: false,
      remark: '',
    };
    (this as any).$refs['form'].resetFields();
    this.$parent.$parent['dialog'] = false;
  }
}
